import { render, staticRenderFns } from "./DetailBerlangganan.vue?vue&type=template&id=88530c36&scoped=true&"
import script from "./DetailBerlangganan.vue?vue&type=script&lang=js&"
export * from "./DetailBerlangganan.vue?vue&type=script&lang=js&"
import style0 from "./DetailBerlangganan.vue?vue&type=style&index=0&id=88530c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88530c36",
  null
  
)

export default component.exports